import { render, staticRenderFns } from "./reducedEmployeeModal.vue?vue&type=template&id=205f6387&scoped=true"
import script from "./reducedEmployeeModal.vue?vue&type=script&lang=js"
export * from "./reducedEmployeeModal.vue?vue&type=script&lang=js"
import style0 from "./reducedEmployeeModal.vue?vue&type=style&index=0&id=205f6387&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205f6387",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('205f6387')) {
      api.createRecord('205f6387', component.options)
    } else {
      api.reload('205f6387', component.options)
    }
    module.hot.accept("./reducedEmployeeModal.vue?vue&type=template&id=205f6387&scoped=true", function () {
      api.rerender('205f6387', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/homeManage/personnelDetail/reducedEmployeeModal.vue"
export default component.exports